import { useCallback } from 'react';

import type { ProjectType } from 'src/data/project';
import type { ImproveContentType } from 'src/data/types';
import { useEffectOnce } from 'src/lib/hooks';
// @ts-expect-error - usePopups does not have types
import { usePopups } from 'src/lib/popups';
import type { ContentTypeDefinition } from 'src/views/ImproveContentTypePopup/lib';

import { ImproveContentTypePopup } from './ImproveContentTypePopup';

const POPUP_KEY = Symbol('IMPROVE_CONTENT_TYPE');

interface Result {
  projectType: ProjectType;
  contentType: ImproveContentType;
}

export const useImproveContentTypePopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(POPUP_KEY, ImproveContentTypePopup);
  });

  return useCallback((): Promise<Result | undefined> => {
    return new Promise((resolve) => {
      popups.openPopup(POPUP_KEY, {
        onSubmit: (result: ContentTypeDefinition) => {
          popups.closePopup(POPUP_KEY);
          resolve({
            projectType: result.projectType,
            contentType: result.contentType,
          });
        },
        onClose: () => {
          popups.closePopup(POPUP_KEY);
          resolve(undefined);
        },
      });
    });
  }, [popups]);
};
